import React from 'react';

import * as S from './CheckBox.styles';

const CheckBox = ({id, children, onChange}) => {
  return (
    <S.CheckMark>
      <input type="checkbox" id={id} onChange={onChange} />
      <label htmlFor={id}>{children}</label>
    </S.CheckMark>
  );
};

export default CheckBox;
